(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["mezkui-breed-reference"] && !Shopify.designMode) return;
  try {
    (() => {
  function initBreedTables() {
    document.querySelectorAll('[data-mez-breed]').forEach(root => {
      if (root.dataset.unitsReady) return;
      root.dataset.unitsReady = 'true';
      const group = root.querySelector('.mez-breed__units');
      const buttons = root.querySelectorAll('[data-mez-breed-unit]');
      buttons.forEach(button => button.addEventListener('click', () => {
        const unit = button.dataset.mezBreedUnit;
        root.querySelectorAll('[data-mez-breed-value]').forEach(cell => {
          const format = value => unit === 'in' ? String(Math.round(Number(value) / 2.54 * 10) / 10) : value;
          const min = format(cell.dataset.minCm);
          const max = format(cell.dataset.maxCm);
          cell.textContent = min === max ? min : min + '–' + max;
        });
        root.querySelectorAll('[data-mez-breed-unit-label]').forEach(label => { label.textContent = unit; });
        buttons.forEach(control => {
          const active = control === button;
          control.setAttribute('aria-pressed', String(active));
          control.classList.toggle('is-active', active);
        });
      }));
      group.hidden = false;
    });
  }
  initBreedTables();
  document.addEventListener('shopify:section:load', initBreedTables);
})();
  } catch(e) { console.error(e); }
})();

})();
